export default __webpack_public_path__ + "static/jiri-e0896190f33a87ba99bc8dc8553b3ed6.jpg";